module.exports = __webpack_public_path__ + "img/man-body-front.0b283c26.png";